import { request} from "@/utils/request";
import { BASE_URL} from "@/constants/config";

const main = `${BASE_URL}api/entity-id-form/`;
const export_forms = `${main}export`;

export const ENTITY_FORMS_ENDPOINTS = {
  main,
  export_forms,
  byId: (id) => `${main}${id}/`,
};

class EntityForms {
  async getForms() {
    const { data } = await request({
      url: ENTITY_FORMS_ENDPOINTS.main,
      method: "GET",
      query: {per_page: 9999}
    });
    return data
  }
  async getForm(id) {
    const { data } = await request({
      url: ENTITY_FORMS_ENDPOINTS.byId(id),
      method: "GET",
    });
    return data;
  }
  async deleteForm(id) {
    await request({
      url: ENTITY_FORMS_ENDPOINTS.byId(id),
      method: "DELETE",
    });
  }
  async editOrCreateForm(id = null, payload = {}) {
    const isEdit = id && id !== 'create';
    const { data, res } = await request({
      url: isEdit ? ENTITY_FORMS_ENDPOINTS.byId(id) : ENTITY_FORMS_ENDPOINTS.main,
      method: isEdit ? "PUT" : "POST",
      body: payload,
    });
    return {data, res}
  }
}

export const EntityFormsService = new EntityForms();
